import {AttributeLink, AttributeSetup, task} from '@acng/frontend-stargazer';
import {Actor} from '../../layout/context/list.js';
import {ctxVotes} from '../context/list';
import {Watch} from '@acng/frontend-relativity';
import {AmateurUpgrade, CreatorTemplateConfig} from 'acng/amateurPool/service/template';
import {get} from 'acng/amateurPool/service/cache.js';
import {feature} from '../service/template.js';
import {toggle} from '@acng/frontend-bounty/style/element.js';
import {HIDDEN} from '@acng/frontend-bounty/dom/attribute.js';
import {remove} from '@acng/frontend-bounty/dom/move.js';
import {setup} from '../service/votes.js';
import {animate} from 'acng/layout/service/animate-class.js';

/**
 * @group DOM Attribute
 */
const name = 'positive-list';

AttributeSetup(name, () => {
  const provide = Actor();
  const watch = Watch(`[${name}]`, ctxVotes);

  AttributeLink(name, (element) =>
    watch(element, (element, list) => {
      const ids = list.filter((vote) => vote.state === 'positive');
      toggle(element, 'empty-positive-list', !ids.length);
      toggle(element, 'filled-positive-list', !!ids.length);

      const observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            toggle(entry.target, 'muuuh', entry.intersectionRatio < 0.99);
          }
        },
        {root: element.querySelector('nova-list'), threshold: [0, 0.99], rootMargin: '20px'},
      );

      provide(
        element,
        async () => [],
        async (vote) => {
          const amateur = await get(`${vote.amateur_id}`);
          const config = CreatorTemplateConfig(amateur);
          config.image = amateur.getMatchMakerImageUrl('800');
          const upgrade = AmateurUpgrade(amateur, config);

          return (element, engine) => {
            upgrade(element, engine);
            observer.observe(element);

            return () => {
            animate(element, 'ng-enter');

            };
          };
        },
        ids,
      );
    }),
  );

  return (element, value, compiler) => {
    if (feature[HIDDEN]) {
      remove(element);
    } else {
      task(compiler, setup());
    }
  };
});

export {name as POSITIVE_LIST};
